<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="isFormInvalid"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' USER'">
    <form #mapForm="ngForm" autocomplete="off" class="users-tab-dialog">
        <div class="user-details">
            <mat-form-field class="fullWidth" (input)="setFormState()">
                <mat-label>Name</mat-label>
                <input matInput [disabled]="!isLocalUser()"
                       [(ngModel)]="data.selectedItem.name" maxlength="255" name="name">
            </mat-form-field>
            <mat-form-field class="fullWidth">
                <mat-label>Origin</mat-label>
                <input matInput required disabled [(ngModel)]="data.selectedItem.origin" maxlength="255" name="origin">
            </mat-form-field>
            <mat-form-field class="fullWidth">
                <mat-label>Groups</mat-label>
                <mat-chip-list aria-label="Fish selection" #chipList disabled>
                    <mat-chip *ngFor="let group of data.selectedItem.groupsDisplayName">{{group}}</mat-chip>
                    <input [matChipInputFor]="chipList">
                </mat-chip-list>
            </mat-form-field>
        </div>
        <divider title="Contact details"></divider>
        <mat-form-field class="fullWidth" *ngFor="let attr of data.selectedItem.dicAttributes; let i = index">
            <mat-label>{{attr.dicAttrName}}</mat-label>
            <input matInput [disabled]="attr.isCombined || !attr.local" (input)="setFormState()"
                   [(ngModel)]="attr.value" maxlength="255" [name]="attr.dicAttrName + i">
        </mat-form-field>
    </form>
</arm-dialog>
